import Icon from '../../../Assets/Icon/CustomIcon';
import dayjs from 'dayjs';
import WorkInfoDetailBottomSheet from './WorkInfoDetailBottomSheet';
import { Virtuoso } from 'react-virtuoso';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import {
  Person as PersonIcon,
  CalendarToday as CalendarTodayIcon,
} from '@mui/icons-material';

function GetStatusBadge(item) {
  const completed = item.status === '완료';
  if (completed) {
    return (
      <span className="inline-flex items-center rounded bg-green-100 px-2 py-0.5 text-[10px] font-bold text-green-700">
        조치 완료
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-700">
      확인 중
    </span>
  );
}

export default function WorkInfoList(props) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  return (
    <>
      <div className="flex h-full min-h-0 flex-1 flex-col">
        <Virtuoso
          className="h-full min-h-0 flex-1"
          data={props.workinfoData}
          computeItemKey={(index, item) => item.nearMissSeq}
          itemContent={(index, item) => {
            const gongjongNm = item.gongjongNm ?? '-';
            // const displayId = item.nearMissSeq ? `#${item.nearMissSeq}` : '';
            return (
              <>
                <article
                  role="button"
                  tabIndex={0}
                  className="overflow-hidden rounded-lg border border-slate-100 bg-white shadow-sm transition-colors active:bg-slate-50"
                  onClick={async () => {
                    props.setSelectedWorkInfo(item);

                    dispatch(
                      BottomSheetActions.SetBottomSheetState({
                        bottom: true,
                        type: 'workInfoDetail',
                      })
                    );
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.currentTarget.click();
                    }
                  }}
                >
                  <div className="flex gap-4 p-4">
                    {item.firstImageUrl ? (
                      <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-md bg-slate-200">
                        <img
                          src={item.firstImageUrl}
                          alt=""
                          className="h-full w-full object-cover"
                          loading="lazy"
                        />
                      </div>
                    ) : (
                      <div className="flex h-20 w-20 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-slate-200">
                        <Icon.WorkInfoBaseImg width={50} height={40} />
                      </div>
                    )}
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex items-start justify-between gap-2">
                        {GetStatusBadge(item)}
                        {/* <span className="flex-shrink-0 text-[11px] text-slate-400">
                        {displayId}
                      </span> */}
                      </div>
                      <h3
                        className="mb-1 line-clamp-2 text-sm leading-tight font-bold text-slate-900"
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {item.content}
                      </h3>
                      <p className="text-xs font-medium text-[#135bec]">
                        {gongjongNm}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between border-t border-slate-100 bg-slate-50 px-4 py-2">
                    <div className="flex items-center gap-1.5">
                      <PersonIcon className="!text-[14px] text-slate-400" />
                      <span className="text-[11px] text-slate-600">
                        {[item.discovererNm].filter(Boolean).join(' ') || '-'}(
                        {item.depNm})
                      </span>
                    </div>
                    {item.occurDate && (
                      <div className="flex items-center gap-1.5">
                        <CalendarTodayIcon className="!text-[14px] text-slate-400" />
                        <span className="text-[11px] text-slate-600">
                          {dayjs(item.occurDate).format('YYYY-MM-DD')}
                        </span>
                      </div>
                    )}
                  </div>
                </article>
                {/* Virtuoso가 아이템별 높이를 캐시하는데, 
                조건부로 마지막 아이템만 마진이 달라지면 
                내부 스크롤 영역 계산이 틀어져서 
                부모를 넘쳐버리는 문제가 발생함 */}
                <div className="h-4" />
              </>
            );
          }}
        />
      </div>

      {bottomSheetState.bottom &&
        bottomSheetState.type === 'workInfoDetail' && (
          <WorkInfoDetailBottomSheet
            workInfoDetail={props.selectedWorkInfo}
            DeleteLogic1={props.DeleteLogic1}
          />
        )}
    </>
  );
}
